import { Link } from '@tanstack/react-router';
import type { ComponentType } from 'react';

import { PortalStaggerItem } from '@/modules/portal/components/ui/portal-motion';
import { Icons } from '@/shared/components/ui/icons';
import { cn } from '@/shared/lib/cn';

interface PortalQuickActionCardProps {
  to: string;
  label: string;
  description?: string;
  icon: ComponentType<{ className?: string }>;
}

export function PortalQuickActionCard({
  to,
  label,
  description,
  icon: Icon,
}: PortalQuickActionCardProps) {
  return (
    <PortalStaggerItem>
      <Link
        to={to}
        className={cn(
          'portal-quick-action group flex items-center gap-4 rounded-2xl p-4',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        )}
      >
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary transition-all duration-200 group-hover:scale-[1.03] group-hover:bg-primary/15">
          <Icon className="h-5 w-5" aria-hidden />
        </span>
        <span className="min-w-0 flex-1">
          <span className="block font-medium text-foreground transition-colors group-hover:text-primary">
            {label}
          </span>
          {description ? (
            <span className="mt-0.5 block text-sm text-muted-foreground">{description}</span>
          ) : null}
        </span>
        <Icons.ChevronRight
          className="h-5 w-5 shrink-0 text-muted-foreground/60 transition-transform duration-200 group-hover:translate-x-0.5 rtl:rotate-180 rtl:group-hover:-translate-x-0.5"
          aria-hidden
        />
      </Link>
    </PortalStaggerItem>
  );
}
